<template>
  <section>
    <FestivalYearBanner />
    <TheArticleList
      linkPath="festivalYearEnglish"
      displayType="card"
      :articles="englishes.data"
      :hasCategory="false"
    >
      <TheListTitle :listTitle="articleTitle" />
    </TheArticleList>
    <TheListPagination
      category="englishes"
      :pages="englishes"
      @update:getUpdatedArticles="$store.dispatch('getUpdatedArticles', $event)"
    />
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';
// import { lazyloading } from '@/utils/lazyloading';
import FestivalYearBanner from '@/components/FestivalYearBanner.vue';
import TheListTitle from '@/components/list/TheListTitle';
import TheArticleList from '@/components/list/TheArticleList';
import TheListPagination from '@/components/list/TheListPagination';

export default {
  name: 'TheEnglishList',
  metaInfo() {
    return {
      title: 'Tainan Fest. Year - English',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Tainan Fest. Year - English',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: 'There are so many wonderful cultural festival in Tainan.',
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    englishes() {
      return this.$store.getters.englishes;
    },
    articleTitle() {
      return getArticleString('english', 'headline');
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
  },
  async mounted() {
    await this.getEnglishList();
    // await lazyloading();
  },
  methods: {
    async getEnglishList() {
      // 載入香科年介紹頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch('getEnglishList');
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    FestivalYearBanner,
    TheListTitle,
    TheArticleList,
    TheListPagination,
  },
};
</script>

<style lang="scss" scoped>
.articles {
  padding-top: 10px;
}
</style>
